import axios from 'axios';

const axiosInstance = axios.create({ timeout: 20 * 1000 });

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('user-jwt') || '';

  if (token) config.headers.authorization = `Bearer ${token}`;

  return config;
}, err => Promise.reject(err));

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const guestPaths = ['/login', '/register', '/confirm'];
      const isGuestPath = guestPaths.some(path => window.location.pathname.startsWith(path));

      localStorage.removeItem('user-jwt');
      if (!isGuestPath) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
